import React from 'react';
import EmailScreen from './Components/EmailScreen';
import ExistingAccountScreen from './Components/ExistingAccountScreen';
import LoadingScreen from './Components/LoadingScreen';
import OnboardingHeader from './Components/OnboardingHeader';
import { useHandoff } from './useHandoff';

/**
 * Entry point of the onboarding handoff landing (`/onboarding/continue`).
 * Drives the loading → (auto-login | login) → app / email-fallback flow.
 */
const HandoffFlow = () => {
	const { screen } = useHandoff();

	const renderScreen = () => {
		if (screen === 'login') return <ExistingAccountScreen />;
		if (screen === 'email') return <EmailScreen />;

		return <LoadingScreen />;
	};

	return (
		<div
			style={{
				minHeight: '100%',
				display: 'flex',
				flexDirection: 'column',
				backgroundColor: '#FFFFFF'
			}}>
			<OnboardingHeader />
			{renderScreen()}
		</div>
	);
};

export default HandoffFlow;
